import { render, staticRenderFns } from "./SalesLayout.vue?vue&type=template&id=781c26ea&scoped=true&"
import script from "./SalesLayout.vue?vue&type=script&lang=js&"
export * from "./SalesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c26ea",
  null
  
)

export default component.exports